// Countries and States keys have to be exact so we can
// refrence them programatically
export const countries = ["Cameroon", "Ghana", "Nigeria", "Togo", "Zambia"];

export const states = {
    Cameroon: [
        "Abong-Mbang",
        "Ako",
        "Akonolinga",
        "Ambam",
        "Bafang",
        "Bafia",
        "Bafoussam (Regional capital)",
        "Bafut (Kingdom)",
        "Bali",
        "Bambili (French)",
        "Bamenda (Regional capital)",
        "Batibo",
        "Bandjoun",
        "Bangem",
        "Banyo",
        "Batouri",
        "Bélabo",
        "Bertoua (Regional capital)",
        "Buea (Regional capital)",
        "Campo",
        "Dimako",
        "Dizangue",
        "Djoum",
        "Douala (Regional capital, port, railhead)",
        "Dschang",
        "Ebolowa",
        "Edéa",
        "Eyumojock",
        "Fontem",
        "Foumban",
        "Foumbot",
        "Fundong",
        "Garoua(Regional capital)",
        "Garoua-Boulaï",
        "Guider",
        "Idenau",
        "Kaélé",
        "Kousséri",
        "Kribi",
        "Kumba",
        "Kumbo",
        "Limbé",
        "Lomié",
        "Loum",
        "Makénéné",
        "Mamfe",
        "Manjo	Littoral",
        "Maroua (Regional capital)",
        "Martap	Adamawa	",
        "Mbalmayo",
        "Mbandjock (Mbandjok)",
        "Mbanga",
        "Mbê	Multiple",
        "Mbengwi",
        "Mbouda",
        "Meiganga",
        "Melong",
        "Menji",
        "Muyuka",
        "Nkoteng",
        "Mokolo",
        "Monatélé",
        "Mora",
        "Mouloudou",
        "Mutengene",
        "Nanga Eboko",
        "Ndu",
        "Ndop",
        "Ngaoundéré (Regional capital, railhead)",
        "Nkambe",
        "Nkongsamba",
        "Nkwen",
        "Obala",
        "Penja",
        "Sa'a",
        "Sangmélima",
        "Santa",
        "Tibati",
        "Tiko",
        "Wum",
        "Yaoundé (capital)",
        "Yagoua",
        "Yokadouma",
    ],

    Ghana: [
        "Ashanti",
        "Bono Region",
        "Bono East Region",
        "Ahafo Region",
        "Central",
        "Eastern",
        "Greater Accra",
        "Oti",
        "Northern",
        "Savannah",
        "North East",
        "Upper East",
        "Upper West",
        "Volta Region",
        "Western Region",
        "Western North",
    ],
    Nigeria: [
        "Abia",
        "Adamawa",
        "Akwa Ibom",
        "Anambra",
        "Bauchi",
        "Bayelsa",
        "Benue",
        "Borno",
        "Cross River",
        "Delta",
        "Ebonyi",
        "Edo",
        "Ekiti",
        "Enugu",
        "FCT - Abuja",
        "Gombe",
        "Imo",
        "Jigawa",
        "Kaduna",
        "Kano",
        "Katsina",
        "Kebbi",
        "Kogi",
        "Kwara",
        "Lagos",
        "Nasarawa",
        "Niger",
        "Ogun",
        "Ondo",
        "Osun",
        "Oyo",
        "Plateau",
        "Rivers",
        "Sokoto",
        "Taraba",
        "Yobe",
        "Zamfara",
    ],
    Togo: ["Centrale", "Kara", "Maritime", "Plateaux", "Savanes"],
    Zambia: [
        "Central",
        "Copperbelt",
        "Eastern",
        "Luapula",
        "Lusaka",
        "Muchinga",
        "North-Western",
        "Northern",
        "Southern",
        "Western",
    ],
};
